







import Vue from "vue";
import { RunRef } from "../../interfaces/RunRef";
import { RestService } from "../../services";
export default Vue.extend({
  props: {
    currentRunRef: {
      type: Object as () => RunRef,
      required: false,
    },
    nihdi: {
      type: String,
      required: true,
    },
  },
  methods: {
    async downloadFile(applicationType: string) {
      if (this.currentRunRef.nr && this.currentRunRef.of?.code) {
        const fileAsBlob = await RestService.downloadFile(
          this.nihdi,
          this.currentRunRef.nr,
          this.currentRunRef.of.code,
          applicationType,
          `dmg`
        );
        const blob = new Blob([fileAsBlob]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const now = new Date();
        const currentMonth = (now.getMonth() + 1).toString();
        const currentDay = now.getDate().toString();
        const yyyyMMdd = `${now.getFullYear().toString()}${
          currentMonth.length == 1 ? "0" + currentMonth : currentMonth
        }${currentDay.length == 1 ? "0" + currentDay : currentDay}`;
        link.download = `${this.nihdi}_Period ${this.currentRunRef.of.code}_RUN ${this.currentRunRef.nr}_Export ${yyyyMMdd}.${applicationType}`;
        link.click();
      }
    },
  },
});
